import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function createGroupReducer(
  state = initialState.groupCreated,
  action
) {
  
  switch (action.type) {
    case types.CREATE_GROUP:
      return initialState.groupCreated;
    case types.CREATE_GROUP_SUCCESS:
      return action.group;
    case types.CREATE_GROUP_FAILED:
      return action.error;
    default:
      return state;
  }
}
